import React from 'react';
import { Link } from 'react-router-dom';

// Simple article card component
const ArticleCard = ({ article }) => {
  // Error prevention: ensure all properties exist before rendering
  if (!article) return null;
  
  // Extract the needed properties with fallbacks to prevent errors
  const {
    slug = '',
    title = 'Untitled Article',
    category = 'Uncategorized',
    date = '',
    imageSrc = '',
    author = {}
  } = article;
  
  // Make sure author name is a string (fixing the specific error)
  const authorName = author && typeof author === 'object' && author.name 
    ? author.name 
    : typeof author === 'string' 
      ? author 
      : 'Unknown Author';

  return (
    <div className="article-card" style={{
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
      backgroundColor: 'white',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {imageSrc && (
        <div className="article-card-image" style={{
          height: '180px',
          overflow: 'hidden',
          position: 'relative'
        }}>
          <Link to={`/news/${slug}`}>
            <img 
              src={imageSrc} 
              alt={title} 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </Link>
        </div>
      )}
      <div className="article-card-content" style={{
        padding: '20px',
        flex: '1',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{marginBottom: '12px'}}>
          <span style={{
            fontSize: '0.8rem',
            fontWeight: '600',
            color: '#6b7280',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            {category}
          </span>
        </div>
        <h3 style={{
          fontSize: '1.125rem',
          fontWeight: '600',
          lineHeight: '1.4',
          marginBottom: '10px'
        }}>
          <Link to={`/news/${slug}`} style={{
            color: '#111827',
            textDecoration: 'none',
            transition: 'color 0.2s ease'
          }}>{title}</Link>
        </h3>
        <div style={{
          marginTop: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: '0.875rem',
          color: '#6b7280'
        }}>
          <span>{authorName}</span>
          <span>{date}</span>
        </div>
      </div>
    </div>
  );
};

// Main component for recommended articles section
const RecommendedArticles = ({ articles = [] }) => {
  // Ensure articles is an array
  const articleList = Array.isArray(articles) ? articles : [];
  
  // If no articles, don't render the section
  if (articleList.length === 0) return null;
  
  return (
    <section style={{
      marginTop: '60px',
      paddingTop: '40px',
      borderTop: '1px solid #e5e7eb'
    }}>
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        marginBottom: '24px'
      }}>Recommended Articles</h2>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '24px'
      }}>
        {articleList.map((article, index) => (
          <ArticleCard key={article.id || index} article={article} />
        ))}
      </div>
    </section>
  );
};

export default RecommendedArticles;